import { ERROR_DEFAULT_MESSAGE } from "@/components/fetcher/fetchInterceptor"
import { PopupLayout } from "../layout/PopupLayout"
import { usePopupStore } from "../store/usePopupStore"
import { pipe } from "fp-ts/lib/function"
import * as O from "fp-ts/Option"
import { useCallback } from "react"

export const toErrorMessageProps = (err: unknown): { message?: string } =>
  pipe(
    typeof err === "object" && err !== null && "message" in err
      ? (err as { message?: unknown }).message
      : undefined,
    O.fromPredicate((m: unknown): m is string => typeof m === "string"),
    O.fold(
      () => ({}),
      (message) => ({ message }),
    ),
  )

type PopupErrorProps = {
  title?: string
  message?: string
  buttons?: { title: string; disabled?: boolean; onClick?: () => void }[]
}

const PopupError = ({
  title = "알림",
  message = ERROR_DEFAULT_MESSAGE,
  buttons,
}: PopupErrorProps) => {
  const { closePopup } = usePopupStore()
  const onClick = useCallback(() => {
    console.log("확인")
    closePopup()
  }, [closePopup])
  const defaultButton: {
    title: string
    disabled?: boolean
    onClick?: () => void
  }[] = [
    {
      title: "확인",
      onClick,
    },
  ]

  return (
    <>
      <PopupLayout
        title={title}
        buttons={
          Array.isArray(buttons) && buttons.length > 0 ? buttons : defaultButton
        }
      >
        <p className="typo-body2 text-rl-gray-font-press text-center break-words whitespace-pre-line">
          {message.replace(/\\n/g, "\n")}
        </p>
      </PopupLayout>
    </>
  )
}

export default PopupError
